import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useSnackbar} from 'notistack';

import {TopUpLocalParams, topUpRealLocal} from '../api';
import {QUERY__USERS} from '../queryKeys';

export const useTopUpReal = () => {
  const queryClient = useQueryClient();
  const {enqueueSnackbar} = useSnackbar();

  return useMutation({
    mutationFn: (params: TopUpLocalParams) => topUpRealLocal(params),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY__USERS],
      }),
    onError: error => {
      enqueueSnackbar(error.message, {
        variant: 'error',
      });
    },
  });
};
